/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '_Layouts/Layout';
import QLoginRedirect from '_Components/Auth/QLoginRedirect';
import Settings from './Settings';
import SettingsSubHeader from './_Containers/SettingsSubHeader';
import UsersSubHeader from './_Containers/UsersSubHeader';

const title = 'Settings';
const titleIcon = 'INTERFACE_GEAR';

const action = props => {
  const location = useLocation();
  const getTabID = () => {
    if (
      props.history.location.search.length > 0 &&
      !props.location.state?.fromMenu
    ) {
      switch (props.history.location.search) {
        case '?tab=pricing':
          window.localStorage.setItem('openedSettings', 'plan-pricing');
          return 'plan-pricing';
        case '?tab=projects':
          window.localStorage.setItem('openedSettings', 'projects');
          return 'projects';
        case '?tab=users':
          window.localStorage.setItem('openedSettings', 'users');
          return 'users';
        case '?tab=account':
          window.localStorage.setItem('openedSettings', 'account-preferences');
          return 'account-preferences';
      }
    } else {
      return (
        window.localStorage.getItem('openedSettings') || 'account-preferences'
      );
    }
  };

  useEffect(() => {
    props.history.location.search.length === 0 && setTabID(getTabID());
  }, [window.localStorage.getItem('openedSettings')]);
  const [tabID, setTabID] = useState(getTabID());
  const [usersTabId, setUsersTabId] = useState(
    location.search.includes('users') ? 'users' : 'groups',
  );

  const subheader = (
    <>
      <SettingsSubHeader getTabId={setTabID} tabID={tabID} />
      {tabID === 'users' && (
        <UsersSubHeader usersTab={usersTabId} setUsersTab={setUsersTabId} />
      )}
    </>
  );
  const body = (
    <Settings
      idpage="settings"
      tabID={tabID}
      usersTabId={usersTabId}
      {...props}
    />
  );
  return (
    <QLoginRedirect>
      <Layout
        body={body}
        allowCollapse={false}
        subHeader={subheader}
        title={title}
        hideMentionsCount
        titleIcon={titleIcon}
        {...props}
      />
    </QLoginRedirect>
  );
};

export default action;
